"use strict";
var $dyn;
(function ($dyn) {
    var shell;
    (function (shell) {
        function navigationPopstateHandler(event) {
            // Edge cases are handled first, normal navigation occurs after we confirm we don't have a special case to handle.
            $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> start of handler.");
            if ($dyn.shell._popstateLoopCount > 100) {
                $dyn.logError("Navigation: Unable to complete browser navigation request.");
                return false;
            }
            $dyn.shell._popstateLoopCount++;
            if (!$dyn.shell._popstateLoopCountResetId) {
                $dyn.shell._popstateLoopCountResetId = window.setTimeout(function () {
                    $dyn.shell._popstateLoopCount = 0;
                    $dyn.shell._popstateLoopCountResetId = null;
                }, 100);
            }
            // Check if this is the first page load, some browsers fire an initial popstate, others don't.
            // (IE and Chrome (v34 +) do not fire, Safari and phantomJS do fire on page load.)
            if (event.state == null) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Empty popstate event");
                return true;
            }
            // Check if navigation is a correction to bring browser history into sync with current client/server navigation stack
            if ($dyn.shell.browserHistory.revert) {
                if ($dyn.shell.browserHistory.duplicateRecord) {
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> remove duplicate record before making the browser history correction.");
                    $dyn.shell.browserHistory.duplicateRecord = false;
                    history.back();
                    return true;
                }
                var delta = $dyn.length($dyn.shell.browserHistory.navigationHistory) - (event.state.historyIndex + 1);
                $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Syncing browser history with client navigation stack, delta = %d", delta);
                if (delta === 0) {
                    $dyn.shell.browserHistory.revert = false;
                    $dyn.shell.browserHistory.goingBack = false;
                    var activatingIndex = history.state.stackIndex;
                    var targetElement = $dyn.shell.stack()[activatingIndex];
                    if (!targetElement) {
                        if ($dyn.shell.canGoBack()) {
                            $dyn.shell.browserHistory.goingBack = true;
                            history.back();
                            return;
                        }
                        else {
                            $dyn.shell.restartNavigationStack();
                            return;
                        }
                    }
                    $dyn.shell.activateElement(targetElement);
                    $dyn.shell._currentStackIndex = activatingIndex;
                    $dyn.shell.resetShellOnNavigation();
                    $dyn.shell.browserHistory.clearForward();
                }
                else {
                    // Edge Case.  Task 880464 : Error handling during navigation.  Log or error?  Concern if no forward history in browser?
                    history.go(delta);
                }
                return true;
            }
            // Browser back command issued while a flyout OR a modal dialog was present
            // Put the browser history back in place and send an Escape keypress or mouseup event to close it.
            // Part of the process is to temporarily undo the user history interaction while the flyouts or dialogs are being closed.
            if ($dyn.shell.browserHistory.undo) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> undo flag was true, set the flag to false and ignore this popstate event.");
                $dyn.shell.browserHistory.undo = false;
                return true;
            }
            // Don't allow the user to move off the form when processing as the form may not be allowed to close after the interaction
            // There are 2 processing periods that are important due to javascript's single thread nature:
            // 1. the client is waiting for the server to return from a blocking interaction
            //    so the javascript thread can process the history.back request immediately. (caught by IsClientProcessing)
            // 2. the client is processing, so the history.back is processed after we finish with the interactions.  Here there are two options:
            //   a. there is a pending browser state change.  We must undo the browser.back action. (caught by newStatePending)
            //   b. No pending state change.  There is no existing way to detect this at the time the popstate is processed, so until needed the browser back will be allowed to process.
            if ($dyn.shell.isProcessing() || $dyn.value($dyn.shell.browserHistory.newStatePending) || $dyn.shell.browserHistory.pivotEvaluationPending || $dyn.shell.isClosingOpenForms) {
                var backClicksToUndo = $dyn.length($dyn.shell.browserHistory.navigationHistory) - (event.state.historyIndex + 1) + ($dyn.shell.browserHistory.duplicateRecord ? 1 : 0);
                if (backClicksToUndo > 0) {
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Until the interactions are processed, we need to unwind the user back action.  Go forward %d browser history entries.", backClicksToUndo);
                    if (event.state.placeHolderState) {
                        document.title = $dyn.label("Shell_LoadingTitle");
                    }
                    $dyn.shell.browserHistory.undo = true;
                    history.go(backClicksToUndo);
                }
                return true;
            }
            // If a flyout is open, we need to make sure they can close and then attempt to close the underlying form.
            // If a dialog (lightbox or slider) is open, we should close that form instead of the primary form.
            var flyoutOpen = $dyn.flyout.flyoutManager.areAnyFlyoutsOpen();
            if (!$dyn.shell.browserHistory.goingBack && (flyoutOpen || $dyn.shell.getCurrentDialog())) {
                var undo_1 = $dyn.length($dyn.shell.browserHistory.navigationHistory) - (event.state.historyIndex + 1) + ($dyn.shell.browserHistory.duplicateRecord ? 1 : 0);
                $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Browser back command issued when flyout or dialog was open");
                if (flyoutOpen) {
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> click to dismiss flyout");
                    $("body").trigger(jQuery.Event("click"));
                }
                else {
                    $($dyn.shell.getCurrentDialog()).trigger(jQuery.Event("keydown", { which: $dyn.ui.KeyCodes.esc, shiftKey: false, ctrlKey: false, metaKey: false, altKey: false }));
                }
                if (undo_1 > 0) {
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Until the flyouts or dialogs are closed, we need to unwind the user action.  Go forward %d browser history entries.", undo_1);
                    if (event.state.placeHolderState) {
                        document.title = $dyn.label("Shell_LoadingTitle");
                    }
                    $dyn.shell.browserHistory.undo = true;
                    history.go(undo_1);
                }
                else {
                    $dyn.shell.setDocumentTitle($dyn.shell.primaryFormCaption());
                }
                // after we unwind the flyout stack, we should try the navigation event again if all the flyouts closed successfully
                if (flyoutOpen) {
                    $.when($dyn.deferred.onTrue(function () {
                        return $dyn.value($dyn.async.pending) === 0;
                    }).done(function () {
                        // if flyouts closed, refire the back navigation
                        $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> non-dialog flyouts should not block the original user interaction with the browser back button.  Replay that action if that the flyout is closed.");
                        if (!$dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                            $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> go(-%d).", undo_1);
                            history.go(-undo_1);
                        }
                    }));
                }
                return true;
            }
            // Go back a second time if we have a duplicate record (used to erase forward browser history) and the user only went back one position in the browser history
            if ($dyn.shell.browserHistory.duplicateRecord) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: popstate handler -> Browser back request when duplicate record is present, executing window.history.back().");
                $dyn.shell.browserHistory.duplicateRecord = false;
                window.history.back();
                return true;
            }
            // The shell is already at the history position the browser is navigating to.
            if ($dyn.length($dyn.shell.browserHistory.navigationHistory) === (event.state.historyIndex + 1)) {
                // Task 880464 : Error handling during navigation
                $dyn.log.navigation && $dyn.log.navigation("Navigation: shell stack is already at the position provided by the popstate event.");
                return true;
            }
            // Something is out of sync, potentially this is a onload popstate fired when returning to the product with a browser back action.
            if ($dyn.length($dyn.shell.browserHistory.navigationHistory) < (event.state.historyIndex + 1)) {
                // Task 880464 : Error handling during navigation
                $dyn.log.navigation && $dyn.log.navigation("Navigation: shell stack is shorter than the position provided by the popstate event.");
                return true;
            }
            // ####### normal backward navigation begins here #######
            var historyCount = $dyn.length($dyn.shell.browserHistory.navigationHistory) - (event.state.historyIndex + 1);
            if ($dyn.popout && event.state.placeHolderState) {
                if (historyCount === 1) {
                    // If we are a popout then simulate a navigate forward so the stacks stay in sync since we do not close the window nor the form.
                    $dyn.shell.browserHistory.undo = true;
                    $dyn.shell.isExiting = false;
                    history.go(1);
                    return true;
                }
                else {
                    // Task 880464 : Error handling during navigation
                    $dyn.log.navigation && $dyn.log.navigation("Navigation: Deep back navigation was requested in a popout. This navigation event is not supported.");
                    return true;
                }
            }
            $dyn.log.navigation &&
                $dyn.log.navigation("Navigation: popstate handler -> Received request to go back %d steps in the browser navigation history.", historyCount);
            $dyn.shell.browserHistory.backNavigationTelemetry(historyCount);
            $dyn.shell.browserHistory.goingBack = true;
            $dyn.shell.isExiting = event.state.placeHolderState ? true : false;
            // Pop our saved navigation history, count how many are marked preserveForm.
            // They were navigated to via the task switcher or were pivot changes.
            // We won't close those forms.
            var preserveCount = 0;
            var tempState;
            for (var i = 0; i < historyCount; i++) {
                $dyn.log.navigation && $dyn.log.navigation("Navigation: navigationHistory.pop() from popstate handler.");
                tempState = $dyn.shell.browserHistory.navigationHistory.pop();
                $dyn.shell.browserHistory.pendingFormCloseStates.push(tempState);
                if (tempState.preserveForm || !$dyn.shell.stack()[tempState.stackIndex]) {
                    preserveCount++;
                }
            }
            if (historyCount - preserveCount > 0) {
                $dyn.shell.browserHistory.requestClose();
            }
            else {
                if (history.state && $dyn.shell.stack()[history.state.stackIndex]) {
                    // If the form has multiple views in the stack, try to save before navigating back to previous view.
                    var targetElement = $dyn.shell.stack()[history.state.stackIndex];
                    var form_1 = $dyn.context(targetElement);
                    var controlElement = form_1.ActiveElement();
                    var isControlDirty = false;
                    if (controlElement) {
                        var control = $dyn.context(controlElement);
                        if (control) {
                            if (control.updateValue) {
                                // Call updaveValue from the active control so that any value changes are processed before navigating back
                                control.updateValue(true);
                            }
                            if (control.isDisplayedValueDirty) {
                                isControlDirty = control.isDisplayedValueDirty();
                            }
                        }
                    }
                    if (!form_1.HasUnchangedInvalidControls() && (form_1.AreDataSourcesDirty() || isControlDirty)) {
                        // We have already verified there are no invalid controls, no need to call AllowSave again.
                        // Therefore, setting the first parameter to false when calling form.executeShorts.
                        form_1.executeShortcuts(false, "SaveRecord");
                    }
                    $.when($dyn.deferred.onTrue(function () {
                        return $dyn.value($dyn.async.pending) === 0;
                    })).done(function () {
                        if (form_1 && !form_1.HasInvalidControls() && !form_1.AreDataSourcesDirty()) {
                            $dyn.shell.browserHistory.pendingFormCloseStates = [];
                            $dyn.shell.browserHistory.completeBackNavigation();
                        }
                        else {
                            $dyn.shell.browserHistory.failedClose();
                        }
                    });
                }
                else {
                    $dyn.shell.browserHistory.pendingFormCloseStates = [];
                    $dyn.shell.browserHistory.completeBackNavigation();
                }
            }
        }
        shell.navigationPopstateHandler = navigationPopstateHandler;
    })(shell = $dyn.shell || ($dyn.shell = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=NavigationPopStateHandler.js.map
